// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"3d775c0f","787":"6e2e2c40"}[chunkId] + ".chunk.js";
};